export default "__VITE_ASSET__7c334957__"